/* eslint-disable react/prop-types */
import EditViewModal from 'components/custom/modal/EditViewModal';
import InputBox from 'components/custom/forms/InputBox';
import LabelInput from 'components/custom/forms/LabelInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useModalManage from 'hooks/custom/useModalManage';
import { Col, Row } from 'react-bootstrap';
import apiEndpoints from 'constants/apiEndpoints';
import useHandleUpdate from './../../../hooks/custom/useHandleUpdate';

const EditRoleModal = ({ show, handleClose, data, actions, handleRefresh }) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();
  const handleUpdate = useHandleUpdate(handleRefresh, handleClose);

  const formik = useFormik({
    initialValues: {
      role_name: data.role_name,
      role_description: data.role_description
    },
    validationSchema: Yup.object({
      role_name: Yup.string()
        .required('Please provide the Role name')
        .max(50, 'Role name cannot be longer than 50 characters')
    }),

    onSubmit: values => {
      handleUpdate(
        { ...values, role_id: data.role_id },
        apiEndpoints.rolesPermission.updateRole(data.role_id),
        setModalLoading,
        'role',
        data.role_name
      );
    }
  });

  return (
    <EditViewModal
      loading={modalLoading}
      loadingText={modalMessage}
      show={show}
      handleClose={handleClose}
      status={'Active'}
      name={data.role_name}
      data={data}
      actions={actions}
      handleSubmit={formik.handleSubmit}
      openEditMode={true}
      title={'Role'}
    >
      {(inputRef, isEditable) => (
        <Row className="gy-2 gx-2">
          <Col xs={12} sm={12}>
            <InputBox>
              <LabelInput
                inputProps={{ ref: inputRef, readOnly: !isEditable }}
                label={'Role Name'}
                controlId={'role_name'}
                formik={formik}
                errorProps={{ tooltip: false }}
                required
              />
            </InputBox>
          </Col>
          <Col xs={12}>
            <InputBox>
              <LabelInput
                label={'Role Description'}
                controlId={'role_description'}
                formik={formik}
                errorProps={{ tooltip: false }}
              />
            </InputBox>
          </Col>
        </Row>
      )}
    </EditViewModal>
  );
};

export default EditRoleModal;
